import { TYPE_META } from "@/lib/api";

export const TypeBadge = ({ type }) => {
  const m = TYPE_META[type] || TYPE_META.free_sc;
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-widest ${m.cls}`}>{m.label}</span>;
};
